import React from "react"
import "./Loader-styles.css"

const Loader = ({ isLoading }) => {
    if (!isLoading) return null
    return <div id="loader-animation"></div>
}

export default Loader
